/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Student's first name (required for initial enrollment)
 */
export type HubSpotEnrollRequestFirstname = string | null;
